import type { FaireProductEntity } from "../../entity_types/product";

export const p_tjxeztmd42: FaireProductEntity = {
  token: "p_tjxeztmd42",
  type: "product",
  name: 'Short Stem All Purpose Glass-Grey-6"H(12oz) - Clearance',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/20cffdff0c2390b6da166f55b100f84156eef93072edaf560891da91e069b8ab.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/78ef8744ca505000059a6f7960898d6a3215cdd00ab74f3fb09589118907052a.jpeg",
  ],
  priceDollars: 6,
  description:
    "Our Short Stem All-Purpose Glass, adds a versatile and stylish addition to your glassware collection. Whether for everyday use or special occasions, this artfully crafted grey glass combines functionality with flair, enhancing your drinking experience with its colorful charm. Dishwasher safe.",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:15.218Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
